/**
 * @param {number} timeUnit
 */
const addLeadingZeros = (timeUnit) => (timeUnit >= 10 ? timeUnit : `0${timeUnit}`);

class TimeService {
    /**
     * @param {number} time
     */
    calculateTimes = (time) => {
        let nbHrs = Math.floor(time / 3600);
        const nbMins = (time - (nbHrs * 3600)) / 60;
        while (nbHrs > 23) {
            nbHrs -= 24;
        }
        const timeStr = `${nbHrs % 12 || 12}:${addLeadingZeros(nbMins)} `;
        return nbHrs >= 12 ? `${timeStr} PM` : `${timeStr} AM`;
    };

    /**
     * @param {number} startTime
     * @param {number} endTime
     */
    calculateShiftTimes = (startTime, endTime) => `${this.calculateTimes(startTime)} - ${this.calculateTimes(endTime)}`;

    /**
     * @param {number} time
     */
    formatSecondsInMinSec = (time) => {
        if (time < 0) {
            return '00:00';
        }
        const minutes = Math.floor(time / (1000 * 60));
        const seconds = Math.floor((time - (minutes * (1000 * 60))) / 1000);
        return `${addLeadingZeros(minutes)}:${addLeadingZeros(seconds)}`;
    };

    /**
     * @param {number} minutes
     * @returns {Date}
     */
    getDateTimeFromMinutes = (minutes) => {
        const today = new Date();
        today.setHours(0, minutes, 0, 0);
        return today;
    }
}

export default (new TimeService());